<template>
    <div id="view">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-book"></i> StandBy Lessons</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
              <router-link v-bind:to="{name: 'sb-add-lesson' }" class="button is-info is-pulled-right">Add new</router-link>
            </div>
            <div class="column">
                <lessons-table :page="page" @search="onSearch" @sort="onOrderBy" @pageChanged="onPageChanged" @schoolChanged="onSchoolChanged" :total="total" v-bind:items="lessons" v-bind:actions="true"></lessons-table>
            </div>
        </div>
    </div>
</template>

<script>
import lodash from 'lodash'
import LessonsTable from "./Table";

export default {
  name: 'sb-lessons-view',
  components: {LessonsTable},
  data() {
        return {
            lessons: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1,
            school_id:null,
        }
  },
  created(){
    this.getLessons();
  },
  methods: {
    onSearch(q){
        this.page = 1;
        this.q = q;
        this.getLessons();
    },
    onOrderBy(orderBy){
        this.page = 1;
        this.orderBy = orderBy;
        this.getLessons();
    },
    onSchoolChanged(school_id){
        this.school_id = school_id;
        this.getLessons();
    },
    onPageChanged(page){
      this.page = page;
      this.getLessons();
    },
    getLessons(){
      let data = {
        page: this.page,
        query: this.q,
        orderBy: this.orderBy,
        school_id: this.school_id
      };
        this.stbyLessonRepo.search(data).then(response => {
            this.lessons = response.data.data;
            this.total = response.data.meta.pagination.total_pages
        });
    },
  },
  watch: {
      'school':function (value) {

      }
  }

}
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/sb-lessons/View.vue